<template>
    <button
            v-if="checkUserRole('supplier')"
            class="btn btn--border btn--fav"
            :class="{active: tender?.isFavorite}"
            @click="handleToggleFavorite"
    >
        {{ tender?.isFavorite ? 'Убрать из избранного' : 'В избранное' }}
    </button>
    <div class="info-card">
        <div class="info-card__list">
            <div class="info-card__item info-card__item--status">
                <span class="info-card__label">Статус</span>
                <div class="info-card__status">
                    <span class="status" :data-status="tender?.status?.name">{{ tender?.status?.name }}</span>
                </div>
            </div>
            <div v-if="tender?.status?.name === 'Активный'" class="info-card__item">
                <span class="info-card__label">До завершения</span>
                <div class="info-card__text">
                    <span>
						<VueCountdown :time="new Date(timeForCounter) - new Date()" v-slot="{ days, hours, minutes, seconds }" @end="onTimeEnd">
							<span v-if="days">{{ days }} Дней </span>
							<span v-if="hours">{{ hours }} Часов </span>
							<span v-if="minutes">{{ minutes }} Минут </span>
							<span v-if="!days && !hours && !minutes && !seconds">Торги окончены</span>
							<span v-else>{{ seconds }} Секунд</span>
						</VueCountdown>
                    </span>
                </div>
            </div>
            <div class="info-card__item">
                <span class="info-card__label">Наименование</span>
                <div class="info-card__text">
                    <span>{{ tender?.name || '-' }}</span>
                </div>
            </div>
            <div class="info-card__item">
                <span class="info-card__label">Тип</span>
                <div class="info-card__text">
                    <span>{{ tender?.type?.name || '-' }}</span>
                </div>
            </div>

            <template  v-if="tender?.type?.name === 'Тендер'">
                <div class="info-card__item">
                    <span class="info-card__label">Способ доставки</span>
                    <div class="info-card__text">
                        <span>{{ descriptionFromArray(tender.deliveries) }}</span>
                    </div>
                </div>
                <div class="info-card__item">
                    <span class="info-card__label">Место доставки</span>
                    <div class="info-card__text">
                        <span>{{ descriptionFromArray(tender.deliveryDestinations) }}</span>
                    </div>
                </div>
            </template>
            <template v-if="(tender?.type?.name !== 'CO' && !checkUserRole('supplier')) && tender?.shopGroups?.length ">
                <div class="info-card__item">
                    <span class="info-card__label">Группы магазинов</span>
                    <div class="info-card__text info-card__text--more">
                        <span>{{ formattedShopsGroups }}</span>
                        <span v-if="tender?.shopGroups?.length" class="show-more"
                              @click="ShowProductCategoriesPopup = true">Показать</span>
                    </div>
                </div>
            </template>
                <template v-if="tender?.distrCenter?.name">
                    <div class="info-card__item">
                        <span class="info-card__label">Распределительный центр</span>
                        <div class="info-card__text">
                            <span>{{ tender?.distrCenter?.name || '-' }}</span>
                        </div>
                    </div>
                </template>

            <div class="info-card__item">
                <span class="info-card__label">Товарная категория</span>
                <div v-for="item in tender?.productCategories" :key="item?.id" class="info-card__text">
                    <span>{{ item?.name }}</span>
                </div>
            </div>

            <div class="info-card__item">
                <span class="info-card__label">Начало торгов</span>
                <div class="info-card__text">
                    <span>{{ tender?.auctionStart || '-' }}</span>
                </div>
            </div>
            <div class="info-card__item">
                <span class="info-card__label">Окончание торгов</span>
                <div class="info-card__text">
                    <span>{{ tender?.auctionEnd || '-' }}</span>
                </div>
            </div>

            <div v-if="tender?.supplyTimeFrom" class="info-card__item">
                <span class="info-card__label">Сроки поставки</span>
                <div class="info-card__text">
                    <span>{{ tender?.supplyTimeFrom || '-' }}</span> - 
                    <span>{{ tender?.supplyTimeTo|| '-' }}</span>
                </div>
            </div>
            
            <template v-if="tender?.type?.name === 'Тендер'">
                <div class="info-card__item">
                    <span class="info-card__label info-card__label--tooltip">Будет ли продлеваться тендер
                        <div class="tooltip">
                            <span class="tooltip__icon"></span>
                            <span class="tooltip__text">Если опция включена, то предложения, сделанные за 5 минут до окончания тендера, продлевают тендер на 5 минут.</span>
                        </div>
                    </span> 
                    <div class="info-card__text">
                        <span>{{ tender?.addTime ? 'Да' : 'Нет' || '-' }}</span>
                    </div>
                </div>                
                <div class="info-card__item">
                    <span class="info-card__label">Шаг цены</span>
                    <div class="info-card__text">
                        <span>{{ tender?.priceStep + ' руб.' || '-' }}</span>
                    </div>
                </div>
            </template>

        </div>
    </div>
    <teleport to="body">
        <transition name="modal" >
            <ProductCategoriesPopup v-if="ShowProductCategoriesPopup" @close="ShowProductCategoriesPopup = false" :data="this.tender.shopGroups"/>
        </transition>
    </teleport>
</template>

<script>
import {getNoun} from "@/utils/helpers";
import {mapActions, mapGetters} from "vuex";
import moment from 'moment-timezone';
import ProductCategoriesPopup from "@/components/sections/Tenders/TenderInner/ProductCategoriesPopup.vue";
import VueCountdown from '@chenfengyuan/vue-countdown';

export default {
    name: "TenderInfo",
    components: {
        ProductCategoriesPopup,
		VueCountdown
    },
    emits: ['updateData'],
    props: {
        tender: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            ShowProductCategoriesPopup: false,
            moment: moment,
        }
    },
    computed: {
        formattedShopsGroups() {
            const length = this.tender.shopGroups?.length
            if (length) {
                return `${length} ${getNoun(length, 'группа', 'группы', 'групп')}`
            }
            return '-'
        },
        timeForCounter() {
            return moment.tz(this.tender.auctionEnd, 'DD.MM.YYYY HH:mm', 'Europe/Moscow').toDate();
        },
        ...mapGetters({
            checkUserRole: 'user/checkUserRole'
        })
    },
    methods: {
        descriptionFromArray(array) {
            if (array?.length) {
                const res = [];
                array.forEach(item => {
                    res.push(item.name)
                });
                return res.join(' / ');
            }
            return '-'
        },
        async handleToggleFavorite() {
            if (this.tender.isFavorite) {
                await this.requestDeleteTenderFromFavorites(this.tender.id);
            } else {
                await this.requestAddTenderToFavorites(this.tender.id);
            }
            this.$emit('updateData')

        },
		onTimeEnd() {
			this.requestTenderDetail(this.tender.id);
		},
        ...mapActions({
            requestAddTenderToFavorites: 'tenders/requestAddTenderToFavorites',
            requestDeleteTenderFromFavorites: 'tenders/requestDeleteTenderFromFavorites',
            requestStoreGroups: 'storeGroups/requestStoreGroups',
			requestTenderDetail: "tenders/requestTenderDetail",
        })
    }
}
</script>
